import homeBanner from './home-banner';
import { mainNavHeight } from './navigation';

const fontSizeTool = () => {
  const sizes = ['medium', 'large', 'x-large'];
  const remFactors = [16, 20, 24];
  const root = document.querySelector('html');
  const tools = document.querySelectorAll('.font-size-tool');
  const storedSize = localStorage.getItem('fontSize');

  if (storedSize) {
    root.dataset.fontSize = storedSize;
  }

  tools.forEach(tool => {
    tool.addEventListener('click', event => {
      event.preventDefault();

      const currentIndex = sizes.indexOf(root.dataset.fontSize);
      const newIndex = currentIndex + 1 === sizes.length ? 0 : currentIndex + 1;

      root.dataset.fontSize = sizes[newIndex];
      localStorage.setItem('fontSize', sizes[newIndex]);
      localStorage.setItem('remFactor', remFactors[newIndex]);

      mainNavHeight(remFactors[newIndex]);
      homeBanner(remFactors[newIndex]);
    });
  });
};

export default fontSizeTool;
